<template>
  <div class="metric-survey-rr">
    <div class="response-group"
      v-for="r in responseGroups"
      v-if="hasResponseGroup(r)"
      :key="r"
      >{{nameForGroup(r)}}: {{responseRateForGroup(r)}} <span v-if="isSchoolDataLoaded">({{responseRecForGroup(r)}} surveys submitted)</span></div>
    <div class="more-survey">Find more survey questions in the <LinkExternalUrl :url="guideURL">School Quality Guide</LinkExternalUrl>.</div>
  </div>
</template>

<script>
import Component from 'vue-class-component'
import { mapGetters } from 'vuex'

import { capitalizeFirstLetter } from '@/utils/data'
import { NS_CURRENT_REPORT } from '../const'

import MetadataBase from './MetadataBase'
import LinkExternalUrl from '@/components/LinkExternalUrl'

const responseGroupLookup = {
  't': 'teacher',
  'p': 'parent',
  's': 'student'
}

/* Valid Slot Names for this Component */
const SN_RR_BY_GROUP = {}
const SN_REC_BY_GROUP = {}
Object.keys(responseGroupLookup).map(d => {
  SN_RR_BY_GROUP[d] = responseGroupLookup[d] + '_rr'
  SN_REC_BY_GROUP[d] = responseGroupLookup[d] + '_rec'
})

@Component({
  computed: {
    ...mapGetters(NS_CURRENT_REPORT, [
      'guideURL'
    ])
  },
  components: {
    LinkExternalUrl
  }
})
export default class MetricSurveyRR extends MetadataBase {
  responseGroups = ['p', 't', 's'] // Display order

  /* Getters */

  /* Methods - utility */

  hasResponseGroup (r) {
    return this.hasSlotName(SN_RR_BY_GROUP[r])
  }
  nameForGroup (r) {
    return capitalizeFirstLetter(responseGroupLookup[r]) + 's'
  }
  responseRateForGroup (r) {
    return this.dispValueForSlotName(SN_RR_BY_GROUP[r])
  }
  responseRecForGroup (r) {
    return this.dispValueForSlotName(SN_REC_BY_GROUP[r])
  }
}
</script>

<style lang="scss">
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.response-group {
  display: block;
  padding-right: 24px;
  &:last-child {
    padding-right: 0px;
  }
}
.more-survey {
  padding-top: 1em;
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/sqs/2020/tab-mods/MetricSurveyRR.vue